import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./modules/App/App";
import { AppSettingsType, AppVariantType } from "./models/appSettings";

const applicationsRoot = document.querySelectorAll("[data-app-variant]");

applicationsRoot.length > 0 &&
  applicationsRoot.forEach((applicationRoot) => {
    if (applicationRoot) {
      const settings: AppSettingsType = {
        applicationRoot: applicationRoot,
        appVariant: applicationRoot.getAttribute(
          "data-app-variant"
        ) as AppVariantType,
        filterDataUrl: applicationRoot.getAttribute("data-filters-api") || "",
        productResultsUrl:
          applicationRoot.getAttribute("data-products-api") || "",
        compareApiUrl: applicationRoot.getAttribute("data-compare-api") || "",
        inquiryApiUrl: applicationRoot.getAttribute("data-inquiry-api") || "",
        errMessage: applicationRoot.getAttribute("data-error-message") || "",
      };

      ReactDOM.render(
        <React.StrictMode>
          <App {...settings} />
        </React.StrictMode>,
        applicationRoot
      );
    }
  });
